import { render, staticRenderFns } from "./ChangePasswordLandingPage.vue?vue&type=template&id=19804fbf&lang=true&"
import script from "./ChangePasswordLandingPage.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports